// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: 9,
    /* Optional */
    // loadProductFirst: true,
  }
};
// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + (bcSfFilterConfig.label) ? bcSfFilterConfig.label.sold_out : '' + '</div>',
    'saleLabelHtml': '<div>' + (bcSfFilterConfig.label) ? bcSfFilterConfig.label.sale : '' + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',
    // Products Template
    'productGridItemHtml': '',
    // Pagination Template
    // 'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousActiveHtml': '<a href="{{itemUrl}}" class="h-8 w-8 flex flex-col justify-center items-center border border-r-0 border-brown-500 bg-white text-brown-500 text-sm">' +
      '<i class="fas fa-chevron-left fa-sm"></i>' +
    '</a>',
    // 'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'previousDisabledHtml': '',
    // 'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextActiveHtml': '<a href="{{itemUrl}}" class="h-8 w-8 flex flex-col justify-center items-center border border-l-0 border-brown-500 bg-white text-brown-500 text-sm">' +
      '<i class="fas fa-chevron-right fa-sm"></i>' +
    '</a>',
    // 'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    // 'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemSelectedHtml': '<div class="h-8 w-8 flex flex-col justify-center items-center border border-brown-500 bg-white text-brown-500 text-sm">' +
      '{{itemTitle}}' +
    '</div>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    // 'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
    'paginateHtml': '<div class="w-full flex flex-row justify-end py-12">' +
      '{{nextMiddle}}' +
      '<div class="w-1/3 flex flex-row justify-end items-center pr-3">' +
        '{{previous}}{{pageItems}}{{next}}{{outOf}}' +
      '</div>' +
    '</div>',
    // Sorting Template
    'sortingHtml': '<div class="px-1 rounded border border-brown-500 text-brown-500 flex flex-row bg-white" style="padding-top: 2px; padding-bottom: 2px;"><select class="collection-sort__input text-brown-500 text-sm bg-transparent outline-none w-full"><option value="manual">Sort By</option>{{sortingItems}}</select><div class="flex flex-col justify-center items-center ml-2" style="padding-top: 2px;"><div style="padding-bottom: 2px"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6"><path d="M3.5,0,7,6H0Z" fill="#707070"></path></svg></div><div class="pb-1" style="padding-top: 2px; padding-bottom: 2px"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6"><path d="M3.5,0,7,6H0Z" transform="translate(7 6) rotate(180)" fill="#707070"></path></svg></div></div></div>',
    'showLimitHtml': '<select id="limit-select" class="text-brown-500 bg-transparent outline-none w-full">{{showLimitItems}}</select>'
};
/************************** BUILD PRODUCT LIST **************************/
// Build Show Limit Item
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ('#bc-sf-filter-top-show-limit').html('');
    var numberList = '9,24,32,48';
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        var label = arr[k];
        showLimitItemsHtml += '<option value="' + arr[k] +'">' + label + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ('#bc-sf-filter-top-show-limit').html(html);
      // Set value
      jQ('#bc-sf-filter-top-show-limit select').val(this.queryParams.limit);
    }
  }
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  var ctx = this;
  function buildProduct () {
    if (!window.vm.main) {
      setTimeout(function() { buildProduct(); }, 150);
    } else {
      window.vm.main.productLoading = true;
      if (index === 1) { window.vm.main.products = []; }
      var product = {};
      /*** Prepare data ***/
      var images = data.images_info;
      // Displaying price base on the policy of Shopify, have to multiple by 100
      var soldOut = !data.available; // Check a product is out of stock
      var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
      var priceVaries = data.price_min != data.price_max; // Check a product has many prices
      // Get First Variant (selected_or_first_available_variant)
      var firstVariant = data['variants'][0];
      if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') {
          firstVariant = paramVariant[0];
        } else {
          for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
              firstVariant = data['variants'][i];
              break;
            }
          }
        }
      }
      /*** End Prepare data ***/
      // Get Template
      var itemHtml = bcSfFilterTemplate.productGridItemHtml;
      // Add Thumbnail
      var itemThumbUrl = images.length > 0 ? images[0]['src'].replace('.jpg', '_x257.jpg').replace('.png', '_x257.png') : bcSfFilterConfig.general.no_image_url;
      var itemHeight = images.length > 0 ? images[0]['height'] : '257px';
      var itemWidth = images.length > 0 ? images[0]['width'] : '257px';
      product.itemThumbUrl = itemThumbUrl;
      product.itemHeight = itemHeight;
      product.itemWidth = itemWidth;
      product.itemSound = null;
      if (data.tags && data.tags.length > 0) {
        for (var i = 0; i < data.tags.length; i++) {
          if (data.tags[i].startsWith('sound:')) {
            product.itemSound = data.tags[i].replace('sound:', '');
            break;
          }
        }
      }
      product.itemPriceHtml = (data && data.price_max) ? '$' + data.price_max.toFixed(2) : '';
      // Add soldOut class
      var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
      product.soldOutClass = soldOutClass;
      // Add onSale class
      var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
      product.saleClass = saleClass;
      // Add soldOut Label
      var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
      product.itemSoldOutLabelHtml = itemSoldOutLabelHtml;
      // Add onSale Label
      var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
      product.itemSaleLabelHtml = itemSaleLabelHtml;
      // Add Vendor
      var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
      product.itemVendorHtml = itemVendorHtml;
      // Add main attribute (Always put at the end of this function)
      product.itemId = data.id;
      product.itemHandle = data.handle;
      product.itemTitle = data.title;
      var prodUrl = ctx.buildProductItemUrl(data);
      product.itemUrl = prodUrl;
      window.vm.main.products.push(product);
      window.vm.main.productLoading = false
    }
    return itemHtml;
  }
  buildProduct();
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};
// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
  for (var k in data) {
    // Add Options
    var optionsArr = [];
    for (var i in data[k]['options_with_values']) {
      optionsArr.push(data[k]['options_with_values'][i]['name']);
    }
    data[k]['options'] = optionsArr;
    // Customize variants
    for (var i in data[k]['variants']) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]['variants'][i];
      // Add Options
      var variantOptions = variant['merged_options'];
      if (Array.isArray(variantOptions)) {
        for (var j = 0; j < variantOptions.length; j++) {
          var temp = variantOptions[j].split(':');
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
          data[k]['variants'][i]['option_' + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]['variants'][i]['options'] = variantOptionArr;
      }
      data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
      data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
    }
    // Add Description
    data[k]['description'] = data[k]['body_html'];
  }
  this.buildPagination(data.length);
  return data;
};
/************************** END BUILD PRODUCT LIST **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ('#bottom-pagination').html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            /*
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            */
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            /*
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            */

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    // pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            if (currentPage < totalPage) {
              paginationHtml = paginationHtml.replace(/{{nextMiddle}}/g, '<div class="w-1/3 flex flex-row justify-center items-center"><a href="' + this.buildToolbarLink('page', currentPage, currentPage + 1) +'" class="text-brown-500 font-bold cursor-pointer text-sm">Next Page&ensp;<i class="fas fa-chevron-right fa-sm"></i></a></div>');
            } else if (currentPage == totalPage) {
              paginationHtml = paginationHtml.replace(/{{nextMiddle}}/g, '');
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            paginationHtml = paginationHtml.replace(/{{outOf}}/g, '<div class="font-thin pl-3 text-sm flex flex-row flex-wrap justify-center items-center text-brown-500">of ' + totalPage + '</div>');
            jQ('#bottom-pagination').html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                if (k !== 'manual') {
                  sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
                }
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {};
